<div class="form-group">
    <div class="input-group">
        <input type="url" class="form-control" name="url" [(ngModel)]="url" (change)="change()"
            [placeholder]="'ADDLAYERS.externalDataSource' | translateHs " required #uri="ngModel"
            style="height: auto;" />

        <button type="button" class="btn btn-secondary" *ngIf="uri.valid" (click)="emitConnect()"><i
                class="icon-link"></i></button>

        <!-- TODO: Following should be validating URL and warning user if URL is invalid -->

        <!-- <button type="button" class="btn btn-danger" *ngIf="uri && !uri.valid"><i
                    class="icon-alertalt"></i></button> -->
        <hs-history-list type="button" (historyUrlSelected)="historySelected($event)" [(what)]="type">
        </hs-history-list>
    </div>
</div>